import { useNavigate } from "react-router-dom";
import projectLogo from "../../../assets/brand_logo_white.png";
import arrowImg from "../../../assets/img-btn-arrow-gradient.png";

const HomeHeader = () => {
  const Token = localStorage.getItem("userId");
  const navigate = useNavigate();

  const handleAboutUs = () => {
    window.open("https://falektayyeb.com/about-us.html", "_blank");
  };

  const handleHome = () => {
    navigate("/");
  };

  const handleFT = () => {
    window.open("https://falektayyeb.com/why-falek-tayyeb.html", "_blank");
  };

  const handleNafis = () => {
    window.open("https://falektayyeb.com/what-is-nafis.html", "_blank");
  };

  const handleLogin = () => {
    if (!Token) {
      navigate("/login");
      // navigate("/");
      return;
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="main_home_header_container">
      <header className="home_header-box">
        <div className="hheader_row">
          <img src={projectLogo} alt="logo" className="header_brand_logo" />
          <div className="home_header_right">
            <div className="home_header_links">
              <p className="hheader_link" onClick={handleHome}>
                Home
              </p>
              <p className="hheader_link" onClick={handleFT}>
                Why Forsatak?
              </p>
              <p className="hheader_link" onClick={handleNafis}>
                What is NAFIS?
              </p>
              <p className="hheader_link" onClick={handleLogin}>
                Dashboard
              </p>
              <p className="hheader_link" onClick={handleAboutUs}>
                About Us
              </p>
            </div>
            <div onClick={handleLogin} className="home_header_btn">
              <div className="fs-14">Post A Job</div>
              <img src={arrowImg} alt="logo" className="home_arrow_btn" />
            </div>
          </div>
        </div>
        {/* <p className="header-description">{description}</p> */}
      </header>
    </div>
  );
};

export default HomeHeader;
